import React from "react";
import about_img from "../assets/about_img.jpg";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div className="flex flex-col md:flex-row gap-2 md:h-[80vh] bg-pimary items-center justify-center p-4 md:px-12 md:py-4">
      {/* Image Section */}
      <div className="flex justify-center">
        <img
          src={about_img}
          alt="Dental Conference 2025"
          loading="lazy"
          className="h-[80%] md:max-h-[100%] w-auto md:w-[80vh] md:mx-16 rounded-2xl object-cover"
        />
      </div>

      {/* Text Content */}
      <div className="flex flex-col w-full md:w-2/3">
        <h1 className="text-xl md:text-3xl font-bold my-2">
          <span className="text-one">Welcome to the Global Hub for</span> Dental
          Innovation
        </h1>
        <p className="text-base my-2">
          Step into the future of Dentistry at IDOM 2025, the most anticipated
            <Link to='https://dentistry.helixconferences.com/' className="text-one" target="_blank"><strong> Dentistry Conference </strong></Link>  of the year. As part of the World Dental Summit
          series, the International Conference on Dentistry and Oral Medicine
          <strong>(IDOM 2025)</strong> brings together Global Dental Professionals, Researchers,
          Clinicians, and Innovators under one roof.
        </p>

        <blockquote className="italic text-one my-2 border-l-4 border-one pl-4">
          “Uniting Global Dentistry Through Knowledge & Innovation.”
        </blockquote>

        <Link to="/about-idom">
          <button className="flex bg-one text-primary px-6 md:px-8 py-2 my-4 rounded-full text-sm md:text-base">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
